import { render } from "./NewProductModal.vue?vue&type=template&id=659b1d36"
import script from "./NewProductModal.vue?vue&type=script&lang=js"
export * from "./NewProductModal.vue?vue&type=script&lang=js"

import "./NewProductModal.vue?vue&type=style&index=0&id=659b1d36&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__